"use client"

import Link from "next/link"

import useAnalytics from "@/hooks/useAnalytics"

type NavItemLinkProps = {
  children?: React.ReactNode
  className?: string
  href: string
  label: string
}

export default function NavItemLink({
  children,
  className,
  href,
  label
}: NavItemLinkProps) {
  const { trackEvent } = useAnalytics()

  return (
    <Link
      className={className}
      href={href}
      onClick={() => {
        void trackEvent({
          action: "Navigation Clicked",
          category: "nav",
          label: label,
          value: href,
        })
      }}
      prefetch={false}
    >
      {children}
    </Link>
  )
}
